import { createSelector } from 'reselect';
import selectors from '@/redux/selectors/selectors.js';
import { appsMetadata, appsVersions } from '@/redux/selectors/workflowSelectors.js';

export const activeCredentialId = (state) => selectors.modal(state, 'credential')?.credentialId;
export const activeCredential = createSelector(
  [activeCredentialId, selectors.credentials], //
  (credentialId, credentials) => credentials?.find((n) => n?.credentialId === credentialId)
);
export const activeCredentialAppMetadata = createSelector(
  [activeCredential, appsMetadata], //
  (credential, appMetadata) => appMetadata?.find((n) => n?.id === credential?.appId)
);
export const activeCredentialApp = createSelector(
  [activeCredential, appsVersions], //
  (credential, appsVersions) => appsVersions?.find((n) => n?.id === credential?.appId)
);
export const activeCredentialAppAuth = createSelector(
  [activeCredential, appsVersions], //
  (credential, appsVersions) => appsVersions?.find((n) => n?.id === credential?.appId)?.authentication?.find((n) => n?.type === credential?.meta?.type)
);

const credentialScreenSelectors = {
  activeCredential,
  activeCredentialId,
  activeCredentialAppMetadata,
  activeCredentialApp,
  activeCredentialAppAuth
};

export default credentialScreenSelectors;
